import styled from "styled-components";
import { Container } from "reactstrap";

export const StyledContainer = styled(Container)`
  margin-bottom: 60px;
  @media (max-width: ${({ theme }) => theme.mobileBp}) {
    font-size: 14px;
  }
  @media (max-width: 575px) {
    && {
      padding: 5px !important;
    }
    margin-bottom: 35px;
  }
`;
